"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        dataCutOff: '2018-09-10 14:48:39.129691+00',
        date: '2018-09-10',
        id: 1,
        senderId: 1,
        timeSlotClose: '2018-09-10 14:48:39.129691+00',
        timeSlotOpen: '2018-09-10 14:48:39.129691+00',
    },
];
